module.exports = __webpack_public_path__ + "img/store.2b30c595.svg";